import React from 'react';
import { LOG_OUT, ACCESS_IS_DENIED_TITLE, ACCESS_IS_DENIED_SUBTITLE, SELECT_SPONSOR } from '../../../const';
import { SELECTED_SPONSOR } from '../../../constants/common';
import { home } from '../../../constants/localUrls';
import AlertIcon from '../../../assets/images/icons/alert.svg';
import PropTypes from 'prop-types';

const ForbiddenComponent = ({
  signOut,
  selectedSponsor,
  sponsors,
  updateSponsorSelection,
  logoutUrl,
  selectTenantAndSetCookie,
  history
}) => {
  const confirmSponsor = (e) => {
    let sponsor = JSON.parse(e.target.value);
    sessionStorage.setItem(SELECTED_SPONSOR, JSON.stringify(sponsor));
    selectTenantAndSetCookie(sponsor);
    history.push(home());
  };

  return (
    <div className="forbidden-page">
      <div className="forbidden-page-header">
        <img src={AlertIcon} alt="forbidden_icon" />
        <div className="forbidden-page-header-title">{ACCESS_IS_DENIED_TITLE}</div>
        <div className="forbidden-page-header-subtitle">{ACCESS_IS_DENIED_SUBTITLE}</div>
      </div>

      <div className="forbidden-page-sponsor-selector">
        <select
          defaultValue={selectedSponsor ? JSON.stringify(selectedSponsor) : undefined}
          onChange={(e) => {
            if (e.target.value !== SELECT_SPONSOR) {
              updateSponsorSelection(e);
              confirmSponsor(e);
            }
          }}
        >
          <option>{SELECT_SPONSOR}</option>
          {sponsors.map((option, id) => {
            return (
              <option key={`select-${id}-option-${option.value}`} value={JSON.stringify(option)}>
                {option.sponsorname}
              </option>
            );
          })}
        </select>
      </div>

      <div className="forbidden-page-logout" onClick={() => signOut(logoutUrl)}>
        <i className="material-icons material-exit">exit_to_app</i>
        <span>{LOG_OUT}</span>
      </div>
    </div>
  );
};

ForbiddenComponent.propTypes = {
  signOut: PropTypes.func,
  selectedSponsor: PropTypes.object,
  sponsors: PropTypes.array,
  updateSponsorSelection: PropTypes.func,
  logoutUrl: PropTypes.string,
  selectTenantAndSetCookie: PropTypes.func,
  history: PropTypes.object
};

export default ForbiddenComponent;
